import React from 'react';

const CaslCheck = (props) => {
	return (
		<div className="app__form-group app__form-group--casl">
			<input id="emco_caslcheck_id" className="app__form-checkbox" type="checkbox" name="caslcheck" onChange={props.handleChange} />
			<label className="app__casl-label" htmlFor="emco_caslcheck_id">
				{props.content.caslcheck}
				<a href={props.policyUrl}>{props.content.policy}</a>
			</label>
			<div className="app__form--error">{props.validation.message}</div>
		</div>
	);
}

export default CaslCheck;



// WEBPACK FOOTER //
// ./src/components/CaslCheck.js